import React from 'react'
import { Divider as AntDivider, DividerProps as AntDividerProps } from 'antd'
import cl from 'classnames'

import styles from './styles.module.scss'

export interface DividerProps extends AntDividerProps {
	spaceAroundHorizontal?: number
}

const Divider: React.FC<DividerProps> = ({ spaceAroundHorizontal = 0, ...props }) => {
	return (
		<AntDivider
			className={cl(styles.root, props.className)}
			style={{
				marginTop: spaceAroundHorizontal,
				marginBottom: spaceAroundHorizontal
			}}
		/>
	)
}

export default Divider
